import { z } from "zod";

export enum PatientImageCategory {
  APPOINTMENT_DOCUMENT = "appointment_document",
  CLINICAL_PHOTO = "clinical_photo",
  IDENTITY_CARD = "identity_card",
  INSURANCE_CARD = "insurance_card",
  MEDICAL_DOCUMENT = "medical_document",
  OTHER = "other",
  SCREENSHOT = "screenshot",
}

export const patientImageAnalysisResultSchema = z.object({
  attachments: z.array(
    z.object({
      category: z.nativeEnum(PatientImageCategory),
      description: z.string(),
      facts: z.array(z.object({ label: z.string(), value: z.string() })),
      index: z.number().int().nonnegative(),
      insurance: z.object({ payer: z.string().nullable(), memberId: z.string().nullable() }).nullable(),
      needsHumanReview: z.boolean(),
      readable: z.boolean(),
      transcription: z.string(),
    })
  ),
});

export type PatientImageAnalysis = z.infer<typeof patientImageAnalysisResultSchema>["attachments"][number];
